import { useEffect, useEffectEvent } from 'react'
import { useSelector } from '@/libs/state'
import { listMembers } from '../application/list-members'
import { members$, membersListVersion$ } from '../store'
import { members as membersPort, notify } from '../wiring'
import type { MemberStatus } from '../domain/member'

const useMembers = (q: string | null, status: string | null) => {
	const members = useSelector(members$)
	const version = useSelector(membersListVersion$)

	const validStatus: MemberStatus | null =
		status === 'active' || status === 'on_leave' || status === 'departed' || status === 'archived' ? status : null

	const reload = useEffectEvent(async () => {
		const result = await listMembers(membersPort, { q, status: validStatus }, notify)
		members$.set(result)
	})

	useEffect(() => {
		reload()
	}, [q, validStatus, version])

	return { members }
}

export { useMembers }
